<template>
	<div class="search-product-brand">
		<div class="search-product-brand__box">
			<input
				class="search-product-brand__input"
				type="text"
				ref="searcher"
				placeholder="제품명이나 브랜드명으로 검색해보세요"
				@keypress.enter.prevent
				@input="searchProduct"
				:disabled="!!selectedObj"
			/>
			<ul
				class="search-product-brand__list"
				v-if="searchList && !selectedObj"
			>
				<li
					class="search-product-brand__list__item"
					v-for="item in searchList"
					:key="item.idProduct"
				>
					<button
						class="search-product-brand__list__button"
						type="button"
						@click="selecting(item.idProduct, item.title)"
					>
						{{ item.title }}
					</button>
				</li>
			</ul>
			<div class="search-product-brand__selected" v-if="!!selectedObj">
				<span class="search-product-brand__selected__name">
					{{ selectedObj.title }}
				</span>
				<button
					class="btn-delete--only-icon search-product-brand__selected__delete-btn"
					type="button"
					@click="cancelSelecting"
				></button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'SearchProductBrand',
		data() {
			return {
				searchList: null,
				selectedObj: null,
			};
		},
		methods: {
			cancelSelecting() {
				this.selectedObj = null;
			},
			selecting(idProduct, title) {
				this.searchList = null;
				this.$refs.searcher.value = '';
				this.selectedObj = { idProduct, title };
			},
			searchProduct: _.debounce(async function (event) {
				if (event.target.value.trim().length < 1) {
					this.searchList = null;
					return;
				}
				try {
					const params = { searchWord: event.target.value.trim() };
					const { data } = await this.$axiosAdmin2.get(
						`/api/products/searchProductsNBrand`,
						{ params }
					);
					if (!Array.isArray(data.data) || data.data.length < 1) {
						this.searchList = null;
						return;
					}
					this.searchList = data.data.map(item => {
						return {
							idProduct: item.idProduct,
							title: `[${item.idProduct}/${item.brandTitle}] ${item.productTitle}`,
						};
					});
				} catch (err) {
					console.error(err);
					alert(
						'제품검색에 오류가 발생했습니다. 개발팀에 문의하세요.'
					);
				}
			}, 500),
		},
	};
</script>

<style lang="scss" scoped>
	DIV.search-product-brand {
		.search-product-brand__box {
			position: relative;
			width: 100%;
			padding-top: 35px;

			&:hover {
				.search-product-brand__input,
				.search-product-brand__list {
					border-color: #b0bac5;
				}
			}
		}

		.search-product-brand__input {
			position: absolute;
			width: 100%;
			top: 0;
			left: 0;

			&:focus {
				border-color: #0099fa !important;

				& + .search-product-brand__list {
					border-color: #0099fa;
				}
			}
		}

		.search-product-brand__list {
			overflow-y: auto;
			width: 100%;
			max-height: 200px;
			border: solid 1px #dfe6ee;
			border-radius: 4px;
		}

		.search-product-brand__list__button {
			overflow: hidden;
			display: block;
			width: 100%;
			padding: 6px 12px;
			text-align: left;
			white-space: nowrap;
			text-overflow: ellipsis;

			&:hover {
				background: #f4f7fa;
			}

			&:active {
				background: #b0bac5;
			}
		}

		.search-product-brand__selected {
			position: relative;
			width: 100%;
			height: 36px;
			border-radius: 4px;
			border: solid 1px #dfe6ee;
			padding-right: 30px;
		}

		.search-product-brand__selected__name {
			width: 100%;
			height: 100%;
			padding: 0 12px;
			line-height: 34px;
		}

		.search-product-brand__selected__delete-btn {
			position: absolute;
			width: 30px;
			top: 2px;
			right: 0;
			padding: 0;
		}
	}
</style>
